export default "__VITE_ASSET__C2TCmlK$__"